import React from "react";
import styles from "./OverviewRow.module.css";

export interface OverviewRowProps {
  /** Wide panel on the left — typically a `GreetingCard`. */
  feature: React.ReactNode;
  /** Up to two cards, stacked in the narrow column beside the feature. */
  children?: React.ReactNode;
}

/**
 * A page's opening row: a wide feature panel with cards stacked beside it,
 * sized so the stack matches the feature's height. Both slots are rendered as
 * the grid's own children, so each card stretches to its track without a
 * wrapper. Stacks under a narrow breakpoint, and the feature spans the row on
 * its own when `children` is empty (e.g. while stats are still loading).
 */
const OverviewRow = ({ feature, children }: OverviewRowProps): React.ReactElement => {
  return (
    <div className={styles.row}>
      {feature}
      {children}
    </div>
  );
};

export default OverviewRow;
